
import { DirectiveBinding, defineComponent } from "vue";

export default defineComponent({
  name: "ToolTip",
  props: {
    tooltipText: {
      type: String,
      required: true,
    },
  },
  directives: {
    tooltip: {
      mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
        el.addEventListener("mouseenter", () => {
          const tooltip = document.createElement("div");
          tooltip.classList.add("tooltip");
          tooltip.innerHTML = binding.value as string;
          document.body.appendChild(tooltip);

          const rect = el.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          tooltip.style.top = `${
            rect.top + window.scrollY - tooltipRect.height - 5
          }px`;
          tooltip.style.left = `${rect.left + rect.width / 2 - 17}px`;
        });

        el.addEventListener("mouseleave", () => {
          const tooltip = document.querySelector(".tooltip");
          if (tooltip) {
            tooltip.remove();
          }
        });
      },
    },
  },
  beforeUnmount() {
    const tooltip = document.querySelector(".tooltip");
    if (tooltip) {
      tooltip.remove();
    }
  },
});
